import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';
import { DataDocumentsSystemModel, DocumentsSystemModel } from '../../models/configuration/documents-system.model';

export class
UpdateDocumentsSystemUseCase
implements UseCase<DataDocumentsSystemModel, DocumentsSystemModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataDocumentsSystemModel
    ):
    Observable<DocumentsSystemModel> {

        return this.repository
            .updateDocumentsSystem(
                params
            );
    }
}